import useReduxAction from '@hooks/useReduxAction'

import type { ModuleState } from '@redux/modules/types'

import { AgencyModel } from '@models/agency'

type UseAgencyRelatedEntityCountsOptions = {
  entityKeys: string[],
  performHttpRequests?: boolean,
}

function useAgencyRelatedEntityCounts(agency: AgencyModel, options: UseAgencyRelatedEntityCountsOptions) {
  const { entityKeys, performHttpRequests } = options

  const { data: agencyRelatedEntityCounts, loading: loadingAgencyRelatedEntityCounts } = useReduxAction(
    'agencies',
    'loadRelatedEntityCounts',
    {
      agencyId: agency.id,
      entity_keys: entityKeys,
    },
    [agency.id, performHttpRequests],
    {
      // @ts-expect-error TS2322
      shouldPerformFn: ({ loading }: ModuleState) => performHttpRequests && !loading,
    },
  )

  return {
    agencyRelatedEntityCounts,
    loading: loadingAgencyRelatedEntityCounts,
  }
}

export default useAgencyRelatedEntityCounts
